/* import __COLOCATED_TEMPLATE__ from './sh-payment-transactions-list-item.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';
import { showModal } from "sh-www/utils/modal-controls";

/**
 * This is and individual transactions list item for the ShPayment
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'li',
  classNames: [
    'SH-c-sh-payment-transactions-list-item',
    'LSG-l-grid',
    'border-top-lsg-black',
    'padding-top-bottom-16px'
  ],
  classNameBindings: [
    '_isOddIndex:background-lsg-xlight-gray',
    '_isOddIndex::background-lsg-white'
  ],

  /**
   * Register services
   */

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /**
   * @param {Number}
   */
  indexInTable: 0,

  /**
   * @param {Function}     Called after we have successfully edited a transaction
   */
  onTransactionEdited: (shPaymentTransaction) => {},

  /** @type {Function} */
  onTransactionDeleted: undefined,

  /**
   * @param {ShPaymentTransaction}
   */
  shPaymentTransaction: null,

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {Boolean}      True if this user can edit the ShPaymentTransaction item
   */
  _isEditable: true,

  /**
   * @type {Boolean}
   */
  _isOddIndex: computed('indexInTable', function() {
    return this.get('indexInTable') % 2 === 1;
  }),

  actions: {
    /**
     *
     */
    onEditShPaymentTransactionClicked: function() {
      let modalModel = {
        shPayment: this.get('shPaymentTransaction.shPayment'),
        shPaymentTransaction: this.get('shPaymentTransaction'),
        onTransactionEdited: () => {
          this.get('onTransactionEdited')();
        }
      };

      showModal(this, 'admin/edit-sh-payment-transaction-modal', modalModel);
    },

    /**
     *
     */
    onDeleteShPaymentTransactionClicked() {
      this.get('onTransactionDeleted')(this.get('shPaymentTransaction'));
    },
  }
});
